<template>
    <div style="font-size:15px">
        <div style="background:#f5f5f5; padding-bottom:15px">
            <div class="head width">
            <!-- <img width="40" src="../assets/LogoBanner.png" alt=""> -->
                <div>
                    <div>西安市呼吸内科医疗质量控制中心</div>
                    <div>Xi'an Respiratory Medicine Medical Quality Control Center</div>
                </div>
                <div style="cursor: pointer;">
                    立即登录
                </div>
            </div>
        </div>
        
        <div class="nav">
            <ul class="width">
                <li :class="current==index ? 'color':''" @click="navigatate(index)" v-for="(item,index) in navList" :key="index">{{item.title}}</li>
            </ul>
        </div>
        <div class="width" :style="'min-height:'+heigth">
            <router-view></router-view>
        </div>
        <div class="footer">
            <div class="width">
                <div>西安市呼吸内科医疗质量控制中心</div>
                <div>咨询电话：173987005687 邮箱地址：67491053556@163.com 技术支持：阿科索健康科技有限公司 i创2号</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            navList:[
                {title:'首页',path:'/index'},
                {title:'科室介绍',path: '/Department'},
                {title:'专家介绍',path: '/authority'},
                {title:'质控专题',path:'/QualityControl'},
                {title:'学术培训',path:'/learningCompontent'},
                {title:'会议通知',path: '/conference'},
                {title:'科普宣教',path:'/popularizationScience'},
            ],
            current: 0,
            heigth:'',
        }
    },
    mounted () {
        var heigth=document.documentElement.clientHeight;
        this.heigth = heigth - 140 - 120 + 'px'
        console.log( this.heigth,heigth)
    },
    methods: {
        navigatate(index){
            this.current = index
            this.$router.push(this.navList[index].path)
        }
    },
    watch:{
        $route:{
            handler(){
                let path = this.$route.fullPath
                for(let i = 0; i<this.navList.length; i++){
                    if(path.includes(this.navList[i].path)){
                        this.current = i
                        break
                    }
                }
            },
            deep:true
        }
    }
}
</script>

<style scoped>
.footer{
    border-top: 3px solid #1b65b9;
    background-color: #f5f5f5;
    padding: 20px 0;
    margin-top: 20px;
    color: #666;
    font-size: 14px;
}
.footer >div{
    line-height: 30px;
}
.width{
    width: 1200px;
    margin: auto;
}
.head{
    color: #c20000;
    display: flex;
    background-size: 100% 100%;
    justify-content: space-between;
    align-items: center;
}
.head div:nth-child(1) div:nth-child(1){
    font-size: 30px;
    margin-bottom: 5px;
    font-weight: 600;
}
.head div:nth-child(1) div:nth-child(2){
    font-weight: 600;
}
.nav ul{
    padding: 0;
    margin: 0 auto;
    display: flex;
}
.nav ul li{
    list-style: none;
    padding: 10px 30px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
}
.nav{
    position: sticky;
    top: 0;
    background-color: #1b65b9;
    margin-bottom: 15px;
    color: #fff;
    z-index: 99;
}
.color{
    background-color: rgba(54, 80, 124,0.7);
}
</style>